import React from "react";
import FloatAnimation from "./floatAnimation";
import { useRef } from "react";

import picEight from "../images/pic-8.jpg";
import community from "../images/community.jpg";
import picFour from "../images/pic-4.jpg";
import picSeven from "../images/pic-7.jpg";
import picTwelve from "../images/pic-12.jpg";

function About() {
  let floatLeaves = useRef(null);
  FloatAnimation(floatLeaves);

  return (
    <div>
      <section
        data-aos="fade-up"
        data-aos-delay="150"
        data-aos-duration="1500"
        className="heading-section"
      >
        <div className="background"></div>
        <div className="overlay"></div>
        <div className="content text-center">
          <p className="page-title">About Us</p>
          <span className="sub-tagline">Building a greener tomorrow 🌿</span>
        </div>
      </section>

      <section className="whoAreWe">
        <div className="container">
          <div className="text-center my-5 who-we-are-section mb-4">
            <h2
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="1500"
              className="main-heading fw-bold"
            >
              Who <span className="leaf-word">Are We?</span>{" "}
              <span ref={floatLeaves} className="leaf-icon">
                🌿
              </span>
            </h2>

            <p
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="1500"
              className="sub-text mx-auto w-75"
            >
              We are a sustainability-driven company rooted in purpose —
              committed to protecting the
              <span className="highlight"> environment</span> and growing
              greener
              <span className="highlight"> communities</span>. Our mission is to
              create lasting impact through
              <span className="highlight"> eco-conscious innovation</span>,
              <span className="highlight"> local engagement</span>, and
              <span className="highlight"> responsible growth</span>. Together,
              we're nurturing a better tomorrow.
            </p>
          </div>

          <div className="row mb-4">
            <div
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-duration="1500"
              className="col-12 col-md-4 mb-4"
            >
              <div className="card">
                <img src={picEight} alt="pic-8.jpg" />
                <p>Eco-Friendly Innovation</p>
                <p>
                  We design solutions that reduce waste, save energy, and
                  promote renewable resources to help build a cleaner future.
                </p>
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="500"
              data-aos-duration="1500"
              className="col-12 col-md-4 mb-4"
            >
              <div className="card">
                <img src={community} alt="community.jpg" />
                <p className="">Community Empowerment</p>
                <p>
                  We work closely with local communities to create green jobs,
                  support education, and encourage environmental awareness.
                </p>
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="600"
              data-aos-duration="1500"
              className="col-12 col-md-4 mb-4"
            >
              <div className="card">
                <img src={picFour} alt="pic-4.jpg" />
                <p>Sustainable Development</p>
                <p>
                  Our projects focus on long-term sustainability—balancing
                  environmental care with economic and social responsibility.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ourStory">
        <div className="row">
          <div className="col-12 col-md-6 column ">
            <div className="card  border-0 shadow-sm p-2 text-center text-md-start text-card h-md-5">
              <h2
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1500"
                className="fw-bold display-6 mb-2"
              >
                Our <span className="text-success">Story</span> 🌿
              </h2>
              <h5
                data-aos="fade-up"
                data-aos-delay="200"
                data-aos-duration="1500"
                className="mb-4"
              >
                We aim to inspire, naturally.
              </h5>
              <p
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1500"
                className=" text-center px-4"
              >
                Our journey began with a simple question:
                <em>
                  “What if beautiful experiences could also be kind to the
                  planet?”
                </em>
                <br />
                <br />
                Fueled by a passion for nature and a deep sense of purpose, we
                set out to craft meaningful products that bring joy without
                harm. But we quickly realized —
                <strong>sustainability isn’t just about materials</strong>, it’s
                about mindset.
                <br />
                <br />
                That’s why we spark inspiration for conscious choices every day,
                showing the world that small steps can grow into lasting impact.
                🌍
                <br />
                <br />
                Rooted in hope, creativity, and green thinking — our story is
                just getting started.
              </p>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="1500"
            className="col-12 col-md-6 column"
          >
            <div className="card image-card">
              <img src={picSeven} alt="pic-7.jpg" />
            </div>
          </div>
        </div>
      </section>

      <section className="action-section">
        <div className="container">
          <div className="row align-items-stretch mt-5 mb-4">
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="1500"
              className="col-12 col-md-6 d-flex flex-column"
            >
              <div className="card w-100">
                <div className="image-card">
                  <img
                    src={picTwelve}
                    alt="pic-12.jpg"
                    className="img-fluid rounded shadow-sm"
                  />
                </div>
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-duration="1500"
              className="col-12 col-md-6 d-flex flex-column "
            >
              <div className="card bg-light border-0 p-4 text-center text-md-start w-100 ">
                <div className="text-card">
                  <h2 className="heading fw-bold display-6 mb-3 text-center">
                    We Make{" "}
                    <span className="text-success">Every Action Count</span> 🌱
                  </h2>
                  <p className="text-center">
                    At our core, we believe that even the smallest actions can
                    spark meaningful change. Whether it’s reducing waste,
                    choosing reusable materials, or supporting local
                    eco-friendly practices, we’re dedicated to weaving
                    sustainability into everyday life.
                    <br />
                    <br />
                    Every choice we make is intentional—designed to protect our
                    planet and inspire others to join the journey toward a
                    greener future.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="1500"
        className="sponsors"
      >
        <div className="sponsor-bar">
          <svg
            width="50px"
            height="50px"
            viewBox="1.91 -84.333 192.757 192.757"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="rgb(29, 65, 48, 0.001)"
              d="M1.91-25.333h192.757v74.755H1.91z"
            />
            <path
              d="M114.738 1.027c-2.424 0-4.328.52-6.233 1.558 0-5.541 0-10.562.174-12.293L97.076-7.631v1.039l1.212.173c1.557.346 2.079 1.211 2.422 3.29.349 4.156.174 26.321 0 29.958 3.117.693 6.408 1.213 9.699 1.213 9.178 0 14.719-5.715 14.719-14.72 0-7.099-4.502-12.295-10.39-12.295zm-3.983 25.109c-.693 0-1.56 0-2.078-.172-.174-2.424-.346-12.642-.174-21.646 1.039-.347 1.731-.52 2.598-.52 3.812 0 5.89 4.502 5.89 10.042-.001 6.929-2.599 12.296-6.236 12.296zM53.436-9.016H22.958v1.558l1.732.173c2.25.346 3.117 1.731 3.462 5.021.521 6.234.347 17.491 0 22.857-.346 3.291-1.211 4.85-3.462 5.021l-1.732.348v1.385h19.568v-1.385l-2.078-.348c-2.251-.172-3.117-1.73-3.463-5.021-.174-2.252-.347-5.889-.347-10.39l4.156.173c2.598 0 3.809 2.078 4.329 5.021h1.559V3.106h-1.559c-.521 2.944-1.731 5.021-4.329 5.021l-4.155.174c0-5.888.173-11.429.347-14.719h6.06c4.677 0 7.101 2.943 8.832 8.139l1.732-.52-.174-10.217z"
              fill=" rgb(29, 65, 48, 0.8)"
            />
            <path
              d="M63.307.681c8.659 0 12.988 5.888 12.988 13.68 0 7.446-4.849 13.682-13.508 13.682-8.658 0-12.987-5.889-12.987-13.682 0-7.446 4.848-13.68 13.507-13.68zm-.52 1.732c-3.81 0-4.849 5.195-4.849 11.948 0 6.58 1.732 11.948 5.196 11.948 3.98 0 5.021-5.195 5.021-11.948 0-6.58-1.73-11.948-5.368-11.948zM127.378 14.535c0-7.1 4.502-13.854 13.334-13.854 7.271 0 10.736 5.369 10.736 12.468h-16.105c-.174 6.407 2.943 11.083 9.178 11.083 2.771 0 4.156-.691 5.889-1.904l.691.865c-1.732 2.424-5.541 4.85-10.389 4.85-7.793-.001-13.334-5.542-13.334-13.508zm7.965-3.29l8.139-.174c0-3.463-.52-8.658-3.463-8.658s-4.504 4.848-4.676 8.832zM172.058 2.067C169.98 1.2 167.21.681 164.093.681c-6.406 0-10.391 3.809-10.391 8.312s2.941 6.407 7.102 7.793c4.328 1.557 5.541 2.77 5.541 4.848s-1.559 3.982-4.33 3.982c-3.289 0-5.715-1.904-7.619-7.1l-1.213.348.174 7.619c2.078.865 5.887 1.559 9.178 1.559 6.754 0 11.084-3.465 11.084-8.832 0-3.637-1.906-5.714-6.408-7.447-4.85-1.904-6.58-3.116-6.58-5.368 0-2.251 1.561-3.81 3.639-3.81 3.115 0 5.193 1.905 6.754 6.581l1.211-.346-.177-6.753zM98.806 1.374c-2.943-1.73-8.139-.866-10.909 5.369l.172-6.061-11.601 2.251v1.039l1.212.173c1.56.174 2.251 1.039 2.425 3.291.346 4.156.173 11.43 0 15.066-.174 2.076-.865 3.115-2.425 3.289l-1.212.174v1.385h16.104v-1.385l-2.078-.174c-1.731-.174-2.251-1.213-2.425-3.289-.346-3.291-.346-9.871-.172-14.027.865-1.213 4.675-2.251 8.138 0l2.771-7.101z"
              fill=" rgb(29, 65, 48, 0.8)"
            />
          </svg>
          <svg
            width="50px"
            height="50px"
            viewBox="0 0 192.756 192.756"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fillRule="evenodd" clipRule="evenodd">
              <path fill="transparent" d="M0 0h192.756v192.756H0V0z" />
              <path d="M73.68 72.423l1.834-5.503c11.692-.229 23.386-.229 35.308-.229l9.857.688 2.064.458 3.211 2.063 1.834 3.21 4.125-3.897 3.211-1.605 5.273-1.146c5.043-.459 10.547-.459 15.82-.459 4.586 0 9.4-.229 14.215.688l3.896 1.375 1.377.688.916.917 1.146.917.688 1.146.688 1.375c.459 0 .918.229 1.605.229l3.898 1.375 1.146.688 1.146.917.916.917.916 1.146.689 1.375.229 1.375.23 2.751c0 2.292-.459 4.356-.918 6.419l-1.375 4.814-7.107-.229c7.336 6.878 8.252 13.526.916 24.302-1.145 1.605-2.293 2.752-3.896 3.898l-1.375.916c-3.211 1.605-6.42 2.293-9.859 2.523-4.586.229-9.4.229-14.215.229-5.502 0-11.006.229-16.279-.918l-2.062-.457c-2.523-.918-4.586-2.064-5.961-4.586-1.377 1.375-2.752 2.521-4.357 3.439-4.355 1.834-8.941 1.834-13.527 1.834-10.775.229-21.551.229-32.327.229h-9.171l.688-2.521c-4.356 2.521-9.63 2.293-14.444 2.521H12.921l-10.088-6.648C9.254 102 15.674 84.575 22.093 66.92h35.079c3.21 0 6.649 0 9.859.459l2.063.688c.917.458 1.605.917 2.522 1.375.917.918 1.376 1.835 2.064 2.981zM8.566 115.525h29.119c6.877 0 11.004-.229 12.38-.229 2.292-.23 4.127-.689 5.502-1.146 1.376-.688 2.522-1.377 3.669-2.752 1.604-1.605 2.979-4.355 4.355-8.252 1.375-4.586 1.605-7.796 0-9.172-.688-.688-1.605-1.146-3.439-1.605 2.292-.458 4.127-1.604 5.273-3.21 1.375-1.375 2.521-3.668 3.439-6.878.916-2.751 1.375-4.814 1.375-6.19 0-1.605-.459-2.751-1.375-3.439-.918-.917-2.522-1.375-5.045-1.605H25.073c-2.751 7.337-5.502 14.444-8.254 22.01-2.75 7.338-5.5 14.902-8.253 22.468zm21.552-27.282h16.966c3.898 0 6.19-.229 6.878-.458 1.146-.458 2.063-1.605 2.522-3.209.688-1.834.459-2.751-.688-3.21-.229 0-2.293-.229-6.189-.229-5.732 0-11.235 0-16.967.229-.917 2.291-1.605 4.584-2.522 6.877zm-5.961 16.277h23.844c.688 0 1.147-.229 1.834-.457 1.146-.459 2.063-1.605 2.751-3.439.688-1.834.459-2.98-.688-3.209-.458-.229-2.98-.229-7.795-.229H26.907c-.916 2.521-1.833 4.814-2.75 7.334zm39.664 11.005h29.118c6.878 0 11.005-.229 12.61-.229a26.267 26.267 0 0 0 5.273-1.146c1.375-.688 2.521-1.605 3.668-2.752 1.605-1.834 2.752-4.586 3.898-8.252 1.375-4.816 1.375-7.796-.23-9.401-.688-.459-1.834-1.146-3.439-1.376 2.293-.688 3.898-1.834 5.045-3.21 1.375-1.604 2.521-3.897 3.439-7.107.688-2.522.916-4.585.916-6.191 0-1.375-.457-2.521-1.375-3.438-1.146-.917-2.752-1.376-5.273-1.376-1.146-.229-4.814-.229-10.775-.229H78.495c-2.521 7.337-4.814 14.674-7.335 22.01-2.524 7.567-5.046 15.131-7.339 22.697zm20.405-27.511h17.196c3.668 0 5.961-.229 6.877-.458 1.148-.458 1.836-1.376 2.293-3.21.689-1.605.459-2.751-.688-2.98-.457-.229-2.521-.229-6.42-.229H86.519c-.688 2.291-1.605 4.584-2.293 6.877zm-5.273 16.506h17.425c3.669 0 5.732 0 6.419-.229.688 0 1.375 0 1.834-.229 1.146-.459 2.064-1.605 2.752-3.439.459-2.062.229-2.98-.918-3.438-.457 0-2.98-.23-7.795-.23H81.475c-.917 2.522-1.605 5.045-2.522 7.565zm43.104-4.125c-.23.688-.459 1.375-.459 2.062-1.146 3.209-1.375 5.732-1.375 7.336.229 1.605.916 2.98 2.062 3.898 1.146.916 3.211 1.605 5.963 1.834 2.979.459 7.336.459 13.525.459 7.338 0 12.381 0 15.133-.23a20.08 20.08 0 0 0 6.42-1.604 15.05 15.05 0 0 0 4.127-3.439c1.604-2.293 2.98-5.273 3.896-9.629.918-3.209 1.146-5.732 1.146-7.566-.229-1.605-.916-2.98-2.062-3.897-1.148-.917-2.752-1.376-4.814-1.834-2.293-.229-6.42-.458-12.84-.688-7.566-.229-11.924-.458-12.84-.688-.916-.459-1.375-1.376-.916-2.98.459-1.605 1.375-2.522 2.521-2.98 1.375-.229 4.586-.459 9.629-.459 4.357 0 7.107 0 8.482.229 1.148 0 2.064.229 2.523.459.459.458.688.688.688 1.146s-.229 1.375-.459 2.522h11.922c.23-.917.459-1.605.459-2.063 1.146-3.897 1.146-6.878.23-8.483-.918-1.605-3.211-2.751-6.65-3.209-2.291-.459-6.418-.688-12.15-.688-8.256 0-13.756.459-16.736.688-2.752.458-5.045 1.604-6.65 3.209-2.291 2.063-4.355 5.502-5.732 10.317-1.145 4.585-1.375 7.795-.459 9.63.459 1.146 1.607 2.063 2.982 2.522 1.375.459 3.668.918 6.418.918 1.605 0 4.814.229 9.859.457 4.816.23 8.025.459 9.4.459 2.062 0 3.211.229 3.898.688.457.459.457 1.375.229 2.752-.459 1.834-1.375 2.979-2.293 3.438a8.524 8.524 0 0 1-2.75.459h-18.343c-.916-.229-1.604-.459-2.062-.918-.688-.457-.688-2.062 0-4.125-3.897-.002-8.024-.002-11.922-.002z" />
            </g>
          </svg>
          <svg
            width="50px"
            height="50px"
            viewBox="0 0 192.756 192.756"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fillRule="evenodd" clipRule="evenodd">
              <path fill="transparent" d="M0 0h192.756v192.756H0V0z" />
              <path d="M92.02 90.371c0 3.534-.353 14.489-.353 14.489 0 2.12.706 3.062 2.709 3.062v.942h-7.892v-.942c2.002 0 3.062-.942 3.062-3.062l.707-17.905c-.589-1.414-1.178-1.885-2.709-2.002v-.824h6.007l6.361 16.727 6.479-16.727h5.418v.824c-1.531 0-2.355.707-2.355 2.356l.707 17.316c0 2.592.471 3.298 2.592 3.298v.942h-9.07v-.942c1.766 0 2.592-.589 2.473-3.298 0 0-.354-12.133-.471-14.253l-4.357 12.015a44.827 44.827 0 0 0-1.65 5.183l-1.412.118c-.354-1.296-1.296-3.651-1.296-3.651s-3.655-10.25-4.95-13.666zM84.599 108.982c-.471-.118-.942-.118-1.414-.118-.942 0-2.592.471-4.594.471-7.657 0-13.311-4.594-13.311-13.075 0-7.185 5.301-12.721 13.428-12.721 1.884 0 4.005.354 5.772 1.06.353-.354.471-.589.824-.942h.707c-.118 1.296-.589 5.536-.589 5.536h-.707c-.471-2.473-1.767-4.123-5.89-4.123-4.947 0-9.423 3.887-9.423 11.073 0 8.128 4.594 11.661 9.659 11.661 3.299 0 5.301-1.884 6.597-4.24l.825.354-1.884 5.064zM62.335 88.722h-.824c-.118-2.238-.825-2.945-2.592-2.945h-3.416v18.494c0 3.062.589 3.651 2.592 3.651v.942H49.26v-.942c2.003 0 2.592-.589 2.592-3.77V85.777h-3.416c-2.238 0-2.592.589-3.181 2.945h-.824l.589-5.301.589.118c.235.589.707.589 2.12.589h11.426c2.121 0 2.592 0 3.063-.707h.707l-.59 5.301z" />
              <path d="M37.363 109.453c-1.649 0-2.945-.235-3.887-.589-.942-.235-1.649-.589-2.002-.824-.471.471-.825 1.06-.825 1.06l-.707-.235.589-5.536.825.118c.471 2.591 2.238 4.476 5.89 4.476 2.827 0 4.712-2.355 4.712-4.947 0-2.12-.825-3.181-3.652-5.301-.942-.589-1.767-1.06-2.474-1.649-2.591-1.648-4.241-3.533-4.241-6.596 0-3.534 2.945-5.89 6.832-5.89 2.238 0 3.652.707 4.123.942l.824-.942.589.118-.589 5.065-.824-.118c0-2.355-1.414-3.416-3.77-3.416-2.238 0-3.887 1.178-3.887 3.416 0 2.003 1.531 3.298 3.298 4.477.942.589 1.649 1.06 2.355 1.531 4.123 2.944 5.065 4.829 5.065 7.656.002 4.122-3.179 7.184-8.244 7.184zM23.935 88.722h-.942c0-2.121-.942-2.945-2.827-2.945h-5.301v9.306h3.416c1.767 0 2.121-.942 2.356-2.474h.824v6.597h-.824c-.235-1.767-.589-2.474-2.474-2.474h-3.298v7.893c0 2.944.707 3.298 2.592 3.298v.942H8.504v-.942c2.238 0 2.591-.589 2.591-3.298V87.308c0-1.649-.707-2.356-2.591-2.356v-.824h12.25c2.12 0 2.591-.118 2.945-.825h.825l-.589 5.419zM151.035 90.135v14.135c0 3.062.705 3.651 2.59 3.651v.942h-13.898v-.942c1.061 0 2.002-.354 2.002-1.06 0-.472-.117-1.296-.354-2.121l-1.061-3.416h-7.773c-.119.472-1.531 4.358-1.531 5.419 0 .942 1.061 1.178 1.766 1.178v.942h-6.479v-.942c1.178 0 2.121-.118 2.945-2.591l6.008-19.201c-.354-.824-.824-1.06-1.648-1.178v-.824h5.301l6.359 20.143c.59 2.12 1.178 3.181 2.121 3.651 1.414-.471 1.768-.942 1.768-3.651V87.308c-1.061-1.414-1.18-2.356-3.182-2.356v-.824h6.008l9.895 16.844V88.133c0-2.592-.588-3.181-2.592-3.181v-.824h13.193v.824c-.824 0-1.531.354-1.531 1.178 0 .589.236 1.178.471 1.885l3.77 8.128 3.652-7.892c.588-1.06.707-1.649.707-2.238 0-.707-.473-1.061-1.531-1.061v-.824h6.242v.824c-1.531 0-2.475 1.414-3.18 3.062l-4.83 9.895v6.479c0 2.828.707 3.534 2.592 3.534v.942h-8.953v-.942c1.885 0 2.592-.706 2.592-3.534v-5.536l-5.184-10.955c-.941-2.12-1.295-2.591-1.885-2.945-1.178.471-1.531 1.296-1.531 3.181v18.14s.119 1.414.236 3.062l-1.531.118-11.544-19.318zm-14.724-1.178l-3.299 10.72h6.832l-3.533-10.72z" />
              <path d="M121.703 99.677h-1.766v5.064c0 2.592.705 3.181 2.709 3.181v.942h-9.07v-.942c1.885 0 2.592-.706 2.592-3.298V88.015c0-2.591-.707-3.062-2.592-3.062v-.824h6.832c6.596 0 10.482 2.002 10.482 7.42.001 5.654-4.71 8.128-9.187 8.128zm-1.178-13.9h-.588v12.132h1.059c3.889 0 5.891-1.767 5.891-6.243s-1.768-5.889-6.362-5.889zM80.593 104.152c-4.476 0-7.539-3.181-7.539-7.774 0-4.358 3.181-7.774 7.539-7.774 4.241 0 7.421 3.298 7.421 7.774.001 4.358-3.298 7.774-7.421 7.774zm0-14.135c-3.062 0-4.123 2.945-4.123 6.361 0 3.181.943 6.361 4.123 6.361 3.063 0 4.005-3.181 4.005-6.479.001-3.18-1.177-6.243-4.005-6.243zM28.765 102.739v-.825c1.178 0 1.414-.353 1.414-.706 0-.472-.118-.825-.236-1.178 0 0-.236-.943-.471-1.649h-4.594l-.471 1.531c-.117.354-.235.707-.235 1.178 0 .472.471.824 1.178.824v.825h-4.594v-.825c1.178 0 1.649-.353 2.12-1.648l3.534-10.602c-.118-.472-.472-.825-1.178-.825v-.825H29a2194.843 2194.843 0 0 0 3.887 11.309c.589 2.002 1.178 2.591 2.12 2.591v.825h-6.242zm-1.65-11.426l-1.767 5.772H29l-1.885-5.772z" />
            </g>
          </svg>
          <svg
            fill="rgb(132, 156 133)"
            width="50px"
            height="50px"
            viewBox="0 -781.7 2059.9 2059.9"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* <style>.st0{fill-rule:evenodd;clip-rule:evenodd}</style> */}
            <path
              className="st0"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 99.9v396.6h61v-27.9H31.2V130H61V99.9H0zm158.2 343.5V156h-66v287.4h66zm66-287.4v114h-54.4v48.2h54.4v125.2H291V156h-66.8zm101.3 74v131.4c0 55.8 31.9 85.2 95.4 87.8v-46.4C402.4 401 393 390.4 393 372V227.1c0-18.2 9.4-28.3 27.9-30.5v-46.8c-63.5 1.8-95.4 28.7-95.4 80.2zm136.1-2.9v144.8c0 18.8-9.4 29-28.7 30.8v46.4c65-1.5 97.6-30.1 97.6-86.3V231.5c0-54.1-32.6-81.7-97.6-82v47.2c19.2 1.7 28.7 11.9 28.7 30.4zm101.2 2.9v131.4c0 55.8 31.9 85.2 95.4 87.8v-46.4c-18.5-1.8-27.9-12.4-27.9-30.8V227.1c0-18.2 9.4-28.3 27.9-30.5v-46.8c-63.4 1.8-95.4 28.7-95.4 80.2zm136.1-2.9v144.8c0 18.8-9.4 29-28.7 30.8v46.4c65-1.5 97.6-30.1 97.6-86.3V231.5c0-54.1-32.6-81.7-97.6-82v47.2c19.3 1.7 28.7 11.9 28.7 30.4zM863.7 156H802v287.4h61.7V156zm79.8 268.2v-99.1l-71.9-146.6v100.1l71.9 145.6zm70.4-268.2h-62.8v287.4h62.8V156zm35.9 0v287.4h67.4V156h-67.4zm102.3 72.2v136.1c0 29.4 7.6 50.5 22.5 63.9 14.9 13.4 38.8 19.9 71.9 19.9v-45.3c-17.8-1.8-26.8-11.7-26.8-28.7V225.7c0-17.1 9-26.9 26.8-29.1v-46.8c-62.8 0-94.4 26.1-94.4 78.4zm104.9-78.7v46.8c20.7.7 31.2 10.5 31.2 29.4V255h64.2v-26.1c0-53-31.9-79.4-95.4-79.4zm0 253.3v45.6h2.9c21.8 0 37.8-8.6 47.5-25.7l14.5 20.6h30.5V273.6h-100.9v43.2h21.4c10.2 0 15.2 6.2 15.2 18.2v39.2c.1 18.4-10.4 28.2-31.1 28.6zM1530.2 156h-85.3L1372 443.4h65.3l50.8-225.3 22.5 116.9h-38.1l-9.4 48.3h57.3l13.4 60.2h69.3L1530.2 156zm154.2 0h-61.7v287.4h61.7V156zm79.8 268.2v-99.1l-71.9-146.6v100.1l71.9 145.6zm70.5-268.2h-62.8v287.4h62.8V156zm92.1 340.3V100.7h-61v30.1h30.1v337.7h-30.1v27.8h61zm33.7-370.7l22.5 8 13.8-54.8 30.5 46.1 18.5-15.2-39.9-39.5 54-3.6-4.4-24.3-51.5 16L2026.5 9l-22.9-9-11.6 54.1-32.6-45.7-18.2 16.3 41.7 37.7-54 3.6 4.7 24.3 51.9-16.4-25 51.7z"
            />
          </svg>
          <svg
            width="50px"
            height="50px"
            viewBox="0 0 192.756 192.756"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fillRule="evenodd" clipRule="evenodd">
              <path fill="transparent" d="M0 0h192.756v192.756H0V0z" />
              <path d="M2.834 105.467h20.235L33.66 87.368H13.505L2.834 105.467zM43.54 87.368h-8.22l-10.671 18.099h8.3L43.54 87.368zM34.925 105.467h5.533l10.591-18.099h-5.533l-10.591 18.099zM43.145 105.467h4.031l10.749-18.099h-4.189l-10.591 18.099zM64.407 87.368h-3.399l-10.591 18.099h3.398l10.592-18.099zM189.922 91.636v-4.347h-35.094v18.1h35.094V94.165h-20.945v4.347h15.175v2.371h-23.476v-9.247h29.246zM142.576 91.873v13.516h5.85v-18.1h-8.615l-11.856 8.141-12.252-8.141h-8.299v18.1h5.85V91.873l11.459 8.379h5.93l11.933-8.379zM103.215 105.389l-9.722-18.1H70.018l-10.67 18.1h6.639l2.292-3.873h26.478l2.055 3.873h6.403zm-13.2-13.753l2.451 5.216H70.651l2.845-5.216h16.519z" />
            </g>
          </svg>
        </div>
      </section>
    </div>
  );
}

export default About;
